import React from 'react'
import { ChangeEvent } from 'react'

import FilterCheckbox from '@cinch/oxd-components/filter-checkbox/src'
import { getInputValue } from '../utils/checkbox-group.utils'

interface CheckboxGroupProps {
  data: { options?: { label: string; value: any }[]; input?: any; meta?: any }
  onChange: (input: any, value: any) => any
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ data, onChange }) => {
  const { meta, input, options } = data
  const { touched, error } = meta
  const { name } = input
  const inputValue = getInputValue(input)

  const getValuesOnChange = (eventTarget: any) => {
    const elemValue = eventTarget.value
    const selectedItems = [...inputValue]
    if (eventTarget.checked) {
      selectedItems.push(elemValue)
    } else {
      selectedItems.splice(selectedItems.indexOf(elemValue), 1)
    }

    return selectedItems
  }

  const handleCheckboxChange = (event: ChangeEvent) => onChange(input, getValuesOnChange(event.target))

  return (
    <>
      <div>
        {options!.map(({ label, value }, index) => (
          <FilterCheckbox
            label={label}
            key={`${name}[${index}]`}
            name={`${name}[${index}]`}
            value={value}
            checked={inputValue.includes(value.toString())}
            onChange={handleCheckboxChange}
            isCustomCheckbox={true}
          />
        ))}
      </div>
      {touched && error && <p className="error">{error}</p>}
    </>
  )
}

export default CheckboxGroup
